export const SERVER_TIMING_EVENT_NAME = 'emb-server-timing';
export const KEY_EMB_SERVER_TIMING_NAME = 'emb.server_timing.name';
export const KEY_EMB_SERVER_TIMING_DURATION = 'emb.server_timing.duration';
export const KEY_EMB_SERVER_TIMING_DESCRIPTION =
  'emb.server_timing.description';
